import { render, staticRenderFns } from "./MenuSpinner.vue?vue&type=template&id=65a3eb25"
import script from "./MenuSpinner.vue?vue&type=script&lang=js"
export * from "./MenuSpinner.vue?vue&type=script&lang=js"
import style0 from "./MenuSpinner.vue?vue&type=style&index=0&id=65a3eb25&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports